import { cva, type VariantProps } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const labelVariants = cva("font-['TT Commons'] font-semibold text-v2-primary", {
  variants: {
    variant: {
      300: "text-xs tracking-[0.24px]",
      400: "text-xxs leading-4 tracking-[0.2px]",
    },
  },
  defaultVariants: {
    variant: 300,
  },
});

type LabelProps = VariantProps<typeof labelVariants> & {
  label: string;
  children: React.ReactNode;
  className?: string;
};

export const Label = ({ label, children, className, variant }: LabelProps) => {
  return (
    <div className={twMerge("flex flex-col gap-2 w-full", className)}>
      <span className={twMerge(labelVariants({ variant }))}>{label}</span>
      {children}
    </div>
  );
};
